const Primary = {
  yellow100: '#FFF9D5',
  yellow200: '#FFF2AC',
  yellow300: '#FFE982',
  yellow400: '#FFE063',
  yellow500: '#FFD130',
  yellow600: '#F1BC00',
  yellow700: '#B78A0E',
  yellow800: '#7A5505',
  YellowMedium: '#FCDC90',
  GreyText: '#333333',
  GreyTextLight: '#8C8C8C',
  GreyLight: '#F0F0F0',
  GreyWhite: '#FAFAFA',
  White: '#FFFFFF',
  GreyDark: '#3F3F3F',
  Grey: '#BDBDBD',
  Black: '#242424',
  GreyMid: '#676767',
} as const;

const Secondary = {
  purple100: '#EEE8FD',
  purple200: '#DCD1FB',
  purple300: '#C5B7F4',
  purple400: '#B0A0E9',
  purple500: '#9280DB',
  purple600: '#6E5DBC',
  purple700: '#4F409D',
  purple800: '#34287F',
  pink100: '#FEF1EC',
  pink200: '#FDE0D9',
  pink300: '#F9CAC4',
  pink400: '#F3B4B3',
  pink500: '#EC999F',
  pink600: '#CA6F7E',
  pink700: '#A94D64',
  pink800: '#711D41',
  red200: '#DA6A5A'
} as const;

const Action = {
  ErrorRed: '#E04E39',
  ErrorRedLight: '#F9DED9',
  SuccessGreen: '#3DB88C',
  SuccessGreenLight: '#DAF1EA'
} as const

const colors = {
  Primary,
  Secondary,
  Action
} as const;

const primaryColors = Object.values(colors.Primary)
const secondaryColors = Object.values(colors.Secondary)
const actionColors = Object.values(colors.Action)

const colorCodes = [...primaryColors, ...secondaryColors, ...actionColors] as const;

export type Color = typeof colorCodes[number] 

export const allColorCodes = (colorCodes as string[]).sort((a, b) => a.localeCompare(b))

export default colors
